import { ProductColor, TypographyVariant, Typography as WebTypography } from '@aloft/toolkit-sui';

import { Text as PDFTypography } from '../../components/pdf-export/Text/Text.tsx';
import { useIsPDF } from '../internal/useIsPDF.ts';

type Props = {
  children: string;
  variant: TypographyVariant;
  color?: ProductColor;
  textAlign?: 'right';
  title?: string;
};

export const Typography = (props: Props) => {
  const { children, title, ...rest } = props;

  if (useIsPDF()) return <PDFTypography {...rest}>{children}</PDFTypography>;

  return (
    <WebTypography title={title} {...rest}>
      {children}
    </WebTypography>
  );
};
